<template>
  <el-dialog
    :title="model.type == 0 ? '选择审批人' : '转移负责人'"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opened()"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item
        :label="model.type == 0 ? '审批人' : '负责人'"
        prop="approval_id"
      >
        <el-select
          size="small"
          v-model="model.approval_id"
          filterable
          :placeholder="model.type == 0 ? '选择审批人' : '选择负责人'"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="审批顺序"
        prop="approve_index"
        v-if="model.type == 0"
      >
        <el-select
          size="small"
          v-model="model.approve_index"
          filterable
          placeholder="审批顺序"
        >
          <el-option :key="0" label="前置" :value="0"></el-option>
          <el-option
            v-if="!model.lastStep"
            :key="1"
            label="后置"
            :value="1"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import DealerSelect from '@/components/select/dealer_select'
import {
  serviceQuestSetApproval,
  userListByAuthCode,
} from '../../service/getData'

export default {
  components: { DealerSelect },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      roles: {
        user: '销售',
        platform_user: '销售',
        telesale: '电话销售',
        dealer: '中间商',
      },
      formRules: {
        approval_id: [
          { required: true, message: '请选择人员', trigger: 'change' },
        ],
      },
      submiting: false,
      users: [],
    }
  },
  methods: {
    async requestUsers() {
      let data = {
        auth_code: this.model.type == 1 ? 171229 : 171101,
        service_quest_id: this.model.id,
      }
      if (this.model.auth_code) {
        data.auth_code = this.model.auth_code
      }
      let res = await userListByAuthCode(data)
      if (res.code == 0) {
        if (!res.data.list) {
          res.data.list = []
        }
        this.users = res.data.list.filter((item) => item.status == 1)
      }
    },
    opened() {
      this.requestUsers()
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await serviceQuestSetApproval(this.model)
          if (res.code == 0) {
            this.$emit('refresh', res.data)
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>